import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { BootstrapButton } from "../../Components/Button/BootstrapButton";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import { Slide, toast } from "react-toastify";
import {
  Paper,
  Tooltip,
  IconButton,
  Modal,
  Box,
  Typography,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Divider,
  Collapse,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../../style/setup.css";
import { EditStore } from "../StoreMaster/EditStorePage";
import { StorePanelCell } from "./CellStoreMapping/StorePanelCell";
import { CellCodeMapping } from "./CellStoreMapping/CellCodeMapping";
import { fetchStoreMasterByStoreId } from "../AuditPlan/DataUtil";

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 68.40%, 44.70%)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

export default function CellStoreMapping() {
  const accessToken = Cookies.get("access_token") || "";

  const { dataId } = useParams();

  const [cellCodeMappingId, setCellCodeMappingId] = useState("");
  const [selectedKodeOutletEdit, setSelectedKodeOutletEdit] = useState("");
  const [selectedPanelEdit, setSelectedPanelEdit] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalOpenCellCodeMapping, setEditModalOpenCellCodeMapping] =
    useState(false);
  const [isModalOpenDetailStore, setIsModalOpenDetailStore] = useState(false);

  const [editedData, setEditedData] = useState({});
  const [editedDataCellCodeMapping, setEditedDataCellCodeMapping] = useState(
    {}
  );
  const [dataMain, setDataMain] = useState([]);
  const [dataProfile, setDataProfile] = useState([]);
  const [dataStoreMasterSpecific, setDataStoreMasterSpecific] = useState({});
  const [noDataFound, setNoDataFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingMainData, setIsFetchingMainData] = useState(false);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);

  const [openSection, setOpenSection] = useState(null);

  const handleCloseEditModal = () => {
    setEditedData({});
    setEditModalOpen(false);
    setOpenSection(null);
  };

  const handleCloseEditModalCellCodeMapping = () => {
    setEditedDataCellCodeMapping({});
    setEditModalOpenCellCodeMapping(false);
    setOpenSection(null);
  };

  const handleCloseModalStoreMasterSpecific = () => {
    setDataStoreMasterSpecific({});
    setIsModalOpenDetailStore(false);
  };

  const handleModalStoreMasterSpecific = async () => {
    const data = await fetchStoreMasterByStoreId(
      accessToken,
      editedData.kodeoutlet
    );
    if (data) {
      setDataStoreMasterSpecific(data);
      setIsModalOpenDetailStore(true);
    } else {
      alert("Kode Outlet tidak ditemukan atau tidak aktif");
    }
  };

  const sections = [
    {
      key: "c1",
      title: "Edit Store Master",
      content: (
        <EditStore
          storeId={dataMain?.store_master_id}
          visibleTitle={false}
          handleClose={() => setOpenSection(null)}
        />
      ),
    },
    {
      key: "c2",
      title: "Edit Store Panel Cell",
      content: (
        <StorePanelCell
          editedData={editedData}
          setEditedData={setEditedData}
          selectedKodeOutletEdit={selectedKodeOutletEdit}
          selectedPanelEdit={selectedPanelEdit}
          editModalOpen={editModalOpen}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          handleModalStoreMasterSpecific={handleModalStoreMasterSpecific}
          handleCloseEditModal={handleCloseEditModal}
        />
      ),
    },
    {
      key: "c3",
      title: "Edit Cell Code Mapping",
      content: (
        <CellCodeMapping
          editDataId={cellCodeMappingId}
          editedData={editedDataCellCodeMapping}
          setEditedData={setEditedDataCellCodeMapping}
          editModalOpen={editModalOpenCellCodeMapping}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          handleCloseEditModal={handleCloseEditModalCellCodeMapping}
        />
      ),
    },
  ];

  async function fetchMainData() {
    setNoDataFound(false);
    setDataMain([]);
    setIsFetchingMainData(true);

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/data-processing/data_preparation/cell-store-mapping/incomplete/${dataId}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const responseData = data.data;

        setDataMain(responseData);

        const { cellcode, panel, storetypecode, areacell } = responseData;

        const isStoreTypeValid = storetypecode !== null && storetypecode !== undefined;

        if (cellcode && panel && isStoreTypeValid && areacell) {
          await fetchCellCodeMappingById(
            cellcode,
            panel,
            storetypecode,
            areacell
          );
        } else {
          setCellCodeMappingId("");
        }
      } else {
        setDataMain([]);
        setNoDataFound(true);
      }
    } catch (error) {
      setDataMain([]);
    }

    setIsFetchingMainData(false);
  }

  async function fetchCellCodeMappingById(
    cellcode,
    panel,
    storetypecode,
    areacell
  ) {
    setCellCodeMappingId("");
    setIsLoading(true);

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?cellcode=${cellcode}&panel=${panel}&storetypecode=${storetypecode}&areacell=${areacell}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.data && data.data.length > 0) {
          setCellCodeMappingId(data.data[0].id);
        } else {
          setCellCodeMappingId("");
        }
      } else {
        setCellCodeMappingId("");
      }
    } catch (error) {
      setCellCodeMappingId("");
    }

    setIsLoading(false);
  }

  const handleUpdateStatus = async () => {
    setIsLoading(true);
    if (!dataId || !dataMain?.panel || !dataMain?.store_id || !dataMain?.period) {
      toast.error("Missing required data.");
      setIsLoading(false);
      return;
    }

    const token = Cookies.get("access_token");
    const panelLower = dataMain.panel.toLowerCase();
    const storeId = dataMain.store_id;
    const periodId = dataMain.period;

    try {
      const updateRawResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/data-processing/data_preparation/${panelLower}/${periodId}/cell-store-mapping/incomplete/update-raw/${storeId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (updateRawResponse.status !== 200) {
        const errorData = await updateRawResponse.json();
        toast.error(errorData.detail || "Gagal update data ke raw!", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          transition: Slide,
        });
        setIsLoading(false);
        return;
      }

      const patchResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/data-processing/data_preparation/cell-store-mapping/incomplete/status/${dataId}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (patchResponse.status === 200) {
        toast.success("Status berhasil diubah!", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          transition: Slide,
        });
        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        const patchError = await patchResponse.json();
        toast.error(patchError.detail || "Status gagal diubah!", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Terjadi kesalahan saat memproses permintaan!", {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
        transition: Slide,
      });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
        "TL",
        "COA",
        "A",
      ]);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (dataId) {
        fetchMainData();
      }
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken, dataId]);

  useEffect(() => {
    if (dataMain && openSection == "c2") {
      setEditedData({
        kodeoutlet: dataMain.store_id,
        panel: dataMain.panel,
        areacell: dataMain.areacell,
        storetypecode: dataMain.storetypecode,
        cellcode: dataMain.cellcode,
      });
      setSelectedKodeOutletEdit(dataMain.store_id);
      setSelectedPanelEdit(dataMain.panel);
    } else if (dataMain && openSection == "c3") {
      setEditedDataCellCodeMapping({
        panel: dataMain.panel,
        areacell: dataMain.areacell,
        storetypecode: dataMain.storetypecode,
        cellcode: dataMain.cellcode,
      });
    }
  }, [openSection]);

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Data Processing"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Data Processing"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      {isFetchingMainData ? (
        <div className="fullscreen-loading">
          <div className="spinner"></div>
        </div>
      ) : dataMain?.is_check === false ? (
        <div style={{ width: "70%", margin: "0 auto", marginTop: "40px" }}> 
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            mb: 2,
            gap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Tooltip title="Back" onClick={() => window.close()}>
              <IconButton size="small">
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="h5" fontWeight={600}>
              Cell Store Mapping - Edit
            </Typography>
          </Box>

          <Button
            variant="contained"
            sx={{
              backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
              border: "1px solid hsl(186, 89.90%, 27.30%)",
              borderRadius: "4px",
              color: "#fff",
              fontSize: { xs: "14px", sm: "16px" },
              padding: "4px 10px",
              textTransform: "none",
              "&:hover": {
                backgroundImage: "linear-gradient(#0991a2, #057d8c)",
              },
            }}
            onClick={fetchMainData}
          >
            Refresh Data
          </Button>
        </Box>
          <Paper sx={{ width: "100%", overflow: "hidden", mb: 5 }}>
            <TableContainer sx={{ maxHeight: 650 }}>
              <Table
                aria-label="simple table"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  borderCollapse: "collapse",
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Kode Outlet
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Nama Outlet
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Kode Kelurahan
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Area Code
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Kode Type Outlet
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Panel
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Area Cell
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Store Type Code
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Cell Code
                    </TableCell>
                    <TableCell
                      style={tableCellStyle}
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      Remarks
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataMain ? (
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.store_id}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.store_name}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.kelcode}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.areacode} ({dataMain.areadesc || "-"})
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.kodetypeoutlet} (
                        {dataMain.namatypeoutlet || "-"})
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.panel}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.areacell}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.storetypecode}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.cellcode || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {dataMain.remarks || "-"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {isLoading ? "Loading..." : "No Data Available"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          {sections.map((section) => (
            <Box sx={{ mb: 4 }} key={section.key}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  mb: 2,
                }}
                onClick={() =>
                  setOpenSection((prev) =>
                    prev === section.key ? null : section.key
                  )
                }
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, fontSize: { xs: 18, sm: 20, md: 24 } }}
                >
                  {section.title}
                </Typography>
                <IconButton size="small">
                  {openSection === section.key ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </IconButton>
              </Box>
              <Collapse
                in={openSection === section.key}
                timeout="auto"
                unmountOnExit
              >
                {section.content}
              </Collapse>
              <Divider sx={{ mt: 4 }} />
            </Box>
          ))}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "100px",
            }}
          > 
            <Button
              variant="contained"
              sx={{
                backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: { xs: "14px", sm: "16px" },
                padding: "10px 16px",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                },
              }}
              onClick={handleUpdateStatus}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Update Raw"}
            </Button>
          </div>
        </div>
      ) : noDataFound && (
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            color: "#2e7d32",
            marginBottom: 2,
            backgroundColor: "#e8f5e9",
            padding: "10px 16px",
            borderRadius: "4px",
          }}
        >
          No data found, or the record has already been marked as complete and requires no further action.
        </Typography>
      )}
      <Modal
        open={isModalOpenDetailStore}
        onClose={handleCloseModalStoreMasterSpecific}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: 0 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
              xs: "90vw",
              sm: 400,
            },
            maxHeight: "90vh",
            bgcolor: "background.paper",
            border: "0px solid #000",
            boxShadow: 24,
            p: {
              xs: 2,
              sm: 4,
            },
            overflowY: "auto",
            borderRadius: 2,
          }}
        >
          <h2>Store Master Detail</h2>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <div>
                <b>Kode Outlet</b> : {dataStoreMasterSpecific.store_id}
              </div>
              <div>
                <b>Nama Outlet</b> : {dataStoreMasterSpecific.store_name}
              </div>
              <div>
                <b>Tipe Outlet</b> : {dataStoreMasterSpecific.store_type}
              </div>
              <div>
                <b>Provinsi</b> : {dataStoreMasterSpecific.province_name}
              </div>
              <div>
                <b>Kab/Kota</b> : {dataStoreMasterSpecific.regency_name}
              </div>
              <div>
                <b>Kel</b> : {dataStoreMasterSpecific.sub_district_name}
              </div>
              <div>
                <b>Kec</b> : {dataStoreMasterSpecific.district_name}
              </div>
              <Button
                variant="outlined"
                disableRipple
                sx={{
                  width: 182,
                  mt: 2,
                  mr: 2,
                  height: 50,
                  color: "#b34469",
                  borderColor: "#b34469",
                }}
                onClick={handleCloseModalStoreMasterSpecific}
              >
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
